import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const getSymptomState = (state: RootState) => state.symptom;

export const selectSymptomSearchResults = createSelector(
  [getSymptomState],
  (healthJourneyState) => healthJourneyState.symptomSearchResults
);

export const selectLoadingSearchSymptoms = createSelector(
  [getSymptomState],
  (healthJourneyState) => healthJourneyState.loadingSearchSymptoms
);

export const selectSymptoms = createSelector(
  [getSymptomState],
  (healthJourneyState) => healthJourneyState.symptoms
);

export const selectLoadingSymptoms = createSelector(
  [getSymptomState],
  (healthJourneyState) => healthJourneyState.loadingSymptoms
);

export const selectSecondLevelBodyParts = createSelector(
  [getSymptomState],
  (symptom) => symptom.secondLevelBodyParts
);

export const selectLoadingInsertSymptoms = createSelector(
  [getSymptomState],
  (healthJourneyState) => healthJourneyState.loadingInsertSymptoms
);

export const selectSymptomsByType = createSelector(
  [getSymptomState],
  (healthJourneyState) => healthJourneyState.symptomsByType
);

export const selectLoadingSymptomsByType = createSelector(
  [getSymptomState],
  (healthJourneyState) => healthJourneyState.loadingSymptomsByType
);
